<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// 使用中文 test2
export default {
  name: "app",
  data() {
    return {
      isMobile: false,
    };
  },
  created() {},
  mounted() {
    document.addEventListener(
      "mousewheel",
      (e) => {
        e = e || window.event;

        if ((e.wheelDelta && event.ctrlKey) || e.detail) {
          event.preventDefault();
        }
      },
      {
        capture: false,

        passive: false,
      }
    );

    document.addEventListener(
      "keydown",
      (event) => {
        if (
          (event.ctrlKey === true || event.metaKey === true) &&
          (event.keyCode === 61 ||
            event.keyCode === 107 ||
            event.keyCode === 173 ||
            event.keyCode === 109 ||
            event.keyCode === 187 ||
            event.keyCode === 189)
        ) {
          event.preventDefault();
        }
      },
      false
    );
  },
  watch: {},
  methods: {},
};
</script>
<style  lang="scss" >
// @import "./assets/font/font.css";
</style>



// WEBPACK FOOTER //
// App.vue